import { h as __h } from "preact";
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import { pluralize } from "~/util/pluralize.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string }} props
 * @param {string[]} user_ids
 */
export const deleteMembers = async ({
  orgId
}, ...user_ids) => {
  const res = await confirmModal({
    title: `Remove ${user_ids.length} ${pluralize(user_ids.length, "member")}?`,
    action: "Remove",
    body: __h("p", {}, "You can re-invite people via their email on the Invites page.")
  });
  if (!res) return;
  try {
    await authedApiRequest("DELETE", `/v2/orgs/${orgId}/members`, {
      json: {
        user_ids
      }
    });
    Query.invalidate([`/v2/orgs/${orgId}/members`], [`/ui/admin/orgs/${orgId}/members`], ...user_ids.map(id => [`/ui/admin/orgs/${orgId}/members/${id}`]), [`/v2/orgs/${orgId}/groups`], [`/ui/admin/orgs/${orgId}/machines`]);
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};